import { get, post } from '../common/http';

const rangeToStartEnd = (dateRange) => {
    const [start, end] = dateRange.split(' - ');
    return {
        startDate: start,
        endDate: end
    }
}

// 공통 파라미터 처리 함수
const processParams = (params) => {
    const apiParams = { ...params };
    if (params.dateRange) {
        const { startDate, endDate } = rangeToStartEnd(params.dateRange);
        apiParams.startDate = startDate;
        apiParams.endDate = endDate;
    }
    return apiParams;
};

class LogApi {
    static async getLogList(params) {
        const apiParams = processParams(params);
        const res = await get('/api/logs', apiParams);
        return res;
    }

    static async getLogCounts(params) {
        const apiParams = processParams(params);
        const res = await get('/api/logs/counts', apiParams);
        return res;
    }
}

export default LogApi;